import createReactComponent from '../createReactComponent';
export default createReactComponent('chevrons-up', 'IconChevronsUp', [
  ['path', { d: 'M7 11l5 -5l5 5', key: 'svg-0' }],
  ['path', { d: 'M7 17l5 -5l5 5', key: 'svg-1' }],
]);
